import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorkOrderCategoriesComponent } from './containers/work-order-categories/work-order-categories.component';

const routes: Routes = [
  {
    path: '',
    component: WorkOrderCategoriesComponent,
    data: { breadcrumb: null },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkOrderCategoriesRoutingModule {}
